import request from './base/api';

export function fetchSchedules(cb, errCb) {
  return request({
    url: 'check-in-system',
    method: 'get',
    cb,
    errCb
  });
}

export function manualCheckIn({ id, phone, password, date }, cb, errCb) {
  const config = {
    data: {
      phone,
      password,
      date
    }
  };

  return request({
    url: `manual-check-in/${id}`,
    method: 'post',
    cb,
    errCb,
    config
  });
}

export default {
  fetchSchedules,
  manualCheckIn
};
